export default __webpack_public_path__ + "static/media/G89A3660.2d1bc2a2.jpg";